export default __webpack_public_path__ + "static/media/ekseed.837ffbe7.png";